// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as SupplierRoutes from "./SupplierRoutes.res.js";
import * as SupplierNewPage from "./SupplierNewPage.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as SupplierEditPage from "./SupplierEditPage.res.js";
import * as SupplierListPage from "./SupplierListPage.res.js";
import * as SupplierShowPage from "./SupplierShowPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SupplierOrderListPage from "./SupplierOrderListPage.res.js";
import * as SupplierEditContactPage from "./SupplierEditContactPage.res.js";
import * as SupplierEditLocationPage from "./SupplierEditLocationPage.res.js";

function SupplierRouter(props) {
  let subUrlPath = props.subUrlPath;
  let url = Navigation.useUrl();
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, SupplierRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  if (subUrlPath === 0) {
    return JsxRuntime.jsx(SupplierListPage.make, {
      supplierBaseRoute: SupplierRoutes.baseRoute,
      supplierNewRoute: SupplierRoutes.newRoute(undefined, undefined),
      supplierShowRoute: SupplierRoutes.showRoute
    });
  }
  let id = subUrlPath.hd;
  let exit = 0;
  if (id === "new" && subUrlPath.tl === 0) {
    let shopId = SupplierRoutes.decodeCreateSupplierQueryString(url.query);
    return JsxRuntime.jsx(SupplierNewPage.make, {
      supplierShowRoute: SupplierRoutes.showRoute,
      shopId: shopId
    });
  }
  exit = 2;
  if (exit === 2) {
    let match = subUrlPath.tl;
    if (match === 0) {
      return JsxRuntime.jsx(SupplierShowPage.make, {
        id: id,
        supplierEditRoute: SupplierRoutes.editRoute,
        supplierEditLocationRoute: SupplierRoutes.editLocationRoute,
        supplierEditContactRoute: SupplierRoutes.editContactRoute,
        supplierBaseRoute: SupplierRoutes.baseRoute
      });
    }
    switch (match.hd) {
      case "edit" :
        let match$1 = match.tl;
        if (match$1 === 0) {
          return JsxRuntime.jsx(SupplierEditPage.make, {
            id: id,
            supplierShowRoute: SupplierRoutes.showRoute
          });
        }
        switch (match$1.hd) {
          case "contact" :
            if (match$1.tl === 0) {
              return JsxRuntime.jsx(SupplierEditContactPage.make, {
                id: id,
                supplierShowRoute: SupplierRoutes.showRoute
              });
            }
            break;
          case "location" :
            if (match$1.tl === 0) {
              return JsxRuntime.jsx(SupplierEditLocationPage.make, {
                id: id,
                supplierShowRoute: SupplierRoutes.showRoute
              });
            }
            break;
        }
        break;
      case "orders" :
        if (match.tl === 0) {
          return JsxRuntime.jsx(SupplierOrderListPage.make, {
            id: id
          });
        }
        break;
    }
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: SupplierRoutes.baseRoute
  });
}

let make = SupplierRouter;

export {
  make,
}
/* Auth Not a pure module */
